// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"3790ad13f4f6ea23","6350":"faccfa20aebb7fc8","7856":"4fb738b0b09addce"}[chunkId] + ".js";
};